import React from "react";
import { useState } from "react";
import * as Yup from "yup";

import FormContainer from "../../components/CustomForm/FormContainer";
import FormImage from "../../components/CustomForm/FormImage";
import CustomToast from "../../components/CustomToast";
import Loader from "../../utils/Loader";
import { getLocalStorageItem } from "../../utils/LocalStorage";
import { useNavigate } from "react-router-dom";
import { addEtambBannerService } from "../../services/etambBannerService";
import { ErrorHandler } from "../../utils/ErrorHandler";

const validationSchema = Yup.object().shape({
  picture: Yup.string().required().label("Image is required"),
});

const AddEtambBanner = () => {
  const [loading, setLoading] = useState(false);
  const token = getLocalStorageItem();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("picture", values["picture"]);
    try {
      const { data } = await addEtambBannerService(formData, token);
      if (data) {
        navigate("/etambBanner");
        CustomToast("success", data);
      }
    } catch (error) {
      ErrorHandler(error).map((e) => CustomToast("error", e.message));
    }
    setLoading(false);
  };
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <FormContainer
          initialValues={{ picture: "" }}
          buttonTitle={"Add Etamb Banner"}
          handleSubmit={handleSubmit}
          validationSchema={validationSchema}
          width={"w-[100%] sm:w-[80%] md:w-[60%] lg:[50%] px-5"}
        >
          <FormImage label={"Image"} name="picture" width={"w-full"} />
        </FormContainer>
      )}
    </div>
  );
};

export default AddEtambBanner;
